import settings from './config';

export const oneTabCheck = () :void => {
  const alertMessage = 'ncass-dashboard-another-tab';

  const channel = new BroadcastChannel('tab');

  channel.postMessage(alertMessage);

  channel.addEventListener('message', (msg) => {
    console.log(msg)
    if (msg.data === alertMessage) {
      const message = encodeURIComponent('This page has closed because you have the Dashboard open in a new tab. Please switch to the new tab to continue.');
      window.location.replace(`${settings.AUTH0.LOGOUT_URL}/?message=${message}`);
    }
  });
}